import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
import get from 'lodash/get';
import clsx from 'clsx';
import { imageSizes, placeholderImages } from '@atc/images';
import { Carousel } from 'reaxl';
import { InventoryListingV2 } from 'reaxl-listing';
import qs from 'querystring';

/**
 *  Carousel for similar inventory
 */
function InventoryCarousel(_ref) {
  let {
    carouselSettings = {},
    className,
    clickType = '',
    isCompared = () => {},
    lazyPlaceholder = placeholderImages.imageLoading,
    listings = [],
    listingClassName,
    onCompareClick = () => {},
    onInventoryListingClick = () => {},
    onListingRemove,
    onListingSelect,
    onNextButtonClick = () => {},
    onPrevButtonClick = () => {},
    onSaveToggle,
    onSettle = () => {},
    onStaticClick = () => {},
    orientation = 'landscape',
    parentId = '',
    savedListingIds = [],
    showCompareButton = false,
    showFooter = true,
    uiContext = 'snapshot',
    ...rest
  } = _ref;
  delete rest.onCollapsibleHeaderClick;
  delete rest.listingCTA;
  delete rest.birfParams;
  delete rest.lazyLoad;
  delete rest.onPricingDetailClick;
  delete rest.paymentsCTA;
  delete rest.onViewOwnerInventoryClick;
  delete rest.onTileClick;
  delete rest.pageValue;
  const getListings = () => listings.map((listing, index) => {
    const modListing = structuredClone(listing);
    const imgIndex = get(modListing, 'images.primary', 0);
    modListing.images = modListing.images ? modListing.images : {
      sources: {}
    };
    modListing.images.sources[imgIndex] = {
      ...modListing.images.sources[imgIndex],
      sizes: imageSizes.inventoryCarousel,
      className: 'img-responsive-scale'
    };
    const addOns = {
      ...listing.addOns
    };
    if (!addOns.emailSent) {
      addOns.onListingSelect = onListingSelect;
      addOns.onListingRemove = onListingRemove;
    }
    const onClick = event => onInventoryListingClick(event, listing, index);
    const onSaveToggleClick = onSaveToggle && ((event, data, isSaved) => {
      onSaveToggle(event, data, isSaved, index);
    });

    // Define the listingCTA prop value if the clickType is specified
    // If a clickType query param is specified  - preserve it
    // Vdp url sample: "/cars-for-sale/vehicledetails.xhtml?listingId=558988226&zip=94566"
    const listingCTA = {};
    if (clickType) {
      const vdpUrl = get(modListing, 'website.href', '');
      const [urlPath = '', urlQuery = ''] = vdpUrl ? vdpUrl.split('?') : [];
      const queryParams = qs.parse(urlQuery);
      queryParams.clickType = queryParams.clickType || clickType;
      listingCTA.href = urlPath ? urlPath + '?' + qs.stringify(queryParams) : '';
    }
    return /*#__PURE__*/_jsx(InventoryListingV2, {
      className: clsx('display-flex flex-column margin-left-3 margin-top-4', listingClassName),
      onClick: onClick,
      addOns: addOns,
      onSaveToggle: onSaveToggleClick,
      isSaved: savedListingIds.includes(listing.id),
      listing: modListing,
      listingCTA: listingCTA,
      ribbon: listing.ribbon,
      lazyLoad: false,
      loading: "eager",
      showFooter: showFooter,
      uiContext: uiContext,
      isCompared: isCompared(modListing),
      onCompareClick: showCompareButton && onCompareClick(modListing),
      clickType: clickType,
      parentId: parentId,
      orientation: orientation
    }, `listing-${listing.id}-${index}`);
  });
  const getCarousel = () => /*#__PURE__*/React.createElement("div", Object.assign({
    "data-cmp": "inventoryCarousel",
    className: clsx('inventory-carousel', className)
  }, rest), /*#__PURE__*/React.createElement(Carousel, Object.assign({
    cellWidth: `${imageSizes.inventoryCarousel.width}px`,
    initialIndex: 0,
    fullHeight: true,
    fullWidth: false,
    onStaticClick: onStaticClick,
    onSettle: onSettle,
    lazyLoad: 1,
    onNextButtonClick: onNextButtonClick,
    onPrevButtonClick: onPrevButtonClick,
    onDragStart: () => {
      document.ontouchmove = e => e.preventDefault();
    },
    onDragEnd: () => {
      document.ontouchmove = () => true;
    }
  }, carouselSettings), getListings()), rest.children);
  return getCarousel();
}
export default InventoryCarousel;